import { generateName } from '@common/Common';
import { ValidationError } from '@common/types';

export class StaticViewBuilderViewModel
{
    closed: boolean = true;
    isSaving: boolean = false;

    name: string | null = null;
    nameError: string | null = null;
    alternativesIds: number[] = [];

    show(alternativesIds: number[])
    {
        this.isSaving = false;

        this.name = generateName("List");
        this.alternativesIds = alternativesIds;

        this.closed = false;
    }

    close()
    {
        this.alternativesIds = [];
        this.closed = true;
    }


    displayValidationErrors(errors: ValidationError[])
    {
        this.isSaving = false;

        for (const error of errors)
        {
            if (error.ErrorCode === "Name.AlreadyExists")
            {
                this.nameError = error.Error;
            }
            else if (error.ErrorCode === "Name.MaxLength")
            {
                this.nameError = error.Error;
            }
        }
    }

    clearValidationErrors()
    {
        this.nameError = null;
    }
}

